// extracted by mini-css-extract-plugin
module.exports = {"item":"Item_item__1SiNc","active":"Item_active__3YHQz","head":"Item_head__1Q0ts","body":"Item_body__1xyn7","button":"Item_button__2_NLH"};